module.exports = __webpack_public_path__ + "static/media/crossGrey.f99709bc.svg";